/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { useChatStore } from '../../../../stores/ChatStore'
import { getSettingAll } from '../../../../api/SettingCRUD'
import useAccessToken from '../../../../hooks/AccessToken'
import { useSettingsStore } from '../../../../stores/SettingsStore'
import { Drawer } from 'rsuite'
import { ListLinkDevice } from '../../../../components/LinkDevice/ListLinkDevice'
import { deleteUserSession, userSession } from '../../../../api/UsersCRUD'
import { useUserSessionStore } from '../../../../stores/UserSessionStore'
import useUser from '../../../../hooks/User'
import moment from 'moment'
import { getCompanies, getThisCompanyCurrency } from '../../../../api/CompanyCRUD'
import { useCompanyStore } from '../../../../stores/CompanyStore'
import useSWR from 'swr'
import axios from 'axios'
import { currencyFormatter, customNumberFormat } from '../../../../functions/general'
import { Subordinate } from '../../../../interfaces/Subordinate'
import { useSubordinateStore } from '../../../../stores/SubordinateStore'
import { useIntl } from 'react-intl'
import { clearDB } from '../../../../db'
import { ExpiredModal } from '../../../../components/ExpiredModal'
import { Modal } from 'bootstrap'
import { ChangePhoneModal } from '../../../../components/ChangePhoneModal';
import { usePipelineStore } from '../../../../stores/PipelineStore';
import { SettingMultiMeetings, SettingMultiMerchants, SettingMultiPipelines } from '../../../../interfaces/Settings';
import { useMerchantStore } from '../../../../stores/MerchantStore';
import { useMeetingStore } from '../../../../stores/MeetingsStore';
import { useAnalyticsStore } from '../../../../stores/Analytics/AnalyticStore';
import { useLocation, useParams } from 'react-router-dom';
import { useUserStore } from '../../../../stores/UserStore';
import { useCurrencyStore } from '../../../../stores/CurrencyStore';
import { useEmailStore } from '../../../../stores/EmailStore';
import { DataLimitEmail } from '../../../../interfaces/Email';
import { useCompanyLimitStore } from '../../../../stores/CompanyLimitStore';
import { useProductStore } from '../../../../stores/ProductStore';
import { useDataTableStore } from '../../../../stores/DataTableStore';
import useModalEffect from '../../../../hooks/useModalEffect';
import { useReimbursementStore } from '../../../../stores/ReimbursementStore';

const API_URL = process.env.REACT_APP_API_URL

interface HeaderUserMenuProps {
  setShowUpdateProfilePicture: React.Dispatch<React.SetStateAction<boolean>>
  userProfile: string
}

const HeaderUserMenu = ({ setShowUpdateProfilePicture, userProfile }: HeaderUserMenuProps) => {
  const user = useUser()
  const token = useAccessToken()
  const intl = useIntl()
  const dispatch = useDispatch()
  const { templatePipelineId } = useParams()
  const { pathname } = useLocation()
  const { setFetchCounter } = useDataTableStore()
  const { setMultiPipelines, setSelectMultiPipeline, setSimplePipelineLoading, setSimplePipelines } = usePipelineStore()
  const { userSessions, setUserSessions } = useUserSessionStore()
  const { remainingLimitMonth, remainingLimitYear, setRemainingLimitMonth, setRemainingLimitYear, setMultiReimbursements } = useReimbursementStore()
  const { setMultiCurrencies } = useCurrencyStore()
  const { setMultiMerchants, setSimpleMerchantLoading, setMerchantLoading, setSimpleMerchants, setMerchants } = useMerchantStore()
  const { setMultiMeetings, setSimpleMeetings, setSimpleMeetingLoading } = useMeetingStore();
  const { setSimpleProducts, setIsLoadingSimpleProducts } = useProductStore();
  const { companies, setCompanies } = useCompanyStore()
  const { setCompanyLimit } = useCompanyLimitStore()
  const { setSettings } = useSettingsStore()
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isShowModalExpired, setIsShowModalExpired] = useState(false);
  const [isShowModalSuspend, setIsShowModalSuspend] = useState(false);
  const { setSubordinates } = useSubordinateStore()
  const { setUsers, setUserLoading } = useUserStore()
  const { setDataLimitMasterEmail } = useEmailStore()
  const { setLimitComponentData } = useAnalyticsStore()
  const { setTemplatesAnalytic } = useAnalyticsStore()

  const fetcher = (url: string) => {
    return axios
      .get(url, {
        headers: {
          'X-Auth-token': token,
        },
      })
      .then((res) => res.data.data)
  }

  const getSetting = async () => {
    try {
      const response = await getSettingAll(token)
      if (response.data.success) {
        setSettings({
          merchant_title: response.data.data.merchant_title ? response.data.data.merchant_title : "Klien",
          merchant_custom_fields: response.data.data.merchant_custom_fields ? response.data.data.merchant_custom_fields : "",
          pipeline_title: response.data.data.pipeline_title ? response.data.data.pipeline_title : "Pipeline",
          pipeline_custom_fields: response.data.data.pipeline_custom_fields ? response.data.data.pipeline_custom_fields : "",
          meeting_title: response.data.data.meeting_title ? response.data.data.meeting_title : "Meeting",
          meeting_custom_fields: response.data.data.meeting_custom_fields ? response.data.data.meeting_custom_fields : "",
          users_title: response.data.data.users_title ? response.data.data.users_title : 'Users',
          reimbursement_title: response.data.data.reimbursement_title ? response.data.data.reimbursement_title : 'Reimbursement',
          users_custom_fields: response.data.data.users_custom_fields ? response.data.data.users_custom_fields : '',
          termins_custom_fields: response.data.data.termins_custom_fields ? response.data.data.termins_custom_fields : '',
          caps_lock_inputs: response.data.data.caps_lock_inputs === "true" ? true : false,
          merchant_duplicate: response.data.data.merchant_duplicate === "true" ? true : false,
          merchant_phone_can_be_changed: response.data.data.merchant_phone_can_be_changed === "true" ? true : false,
          hide_top_three_sales: response.data.data.hide_top_three_sales === "true" ? true : false,
          feature_check_number: response.data.data.feature_check_number === "true" ? true : false,
          feature_pipeline: response.data.data.feature_pipeline === "true" ? true : false,
          feature_meeting: response.data.data.feature_meeting === "true" ? true : false,
          feature_chat: response.data.data.feature_chat === "true" ? true : false,
          feature_chat_super_admin: response.data.data.feature_chat_super_admin === "true" ? true : false,
          pipeline_abandoned_lock: response.data.data.pipeline_abandoned_lock === "true" ? true : false,
          pipeline_date_min: response.data.data.pipeline_date_min ? response.data.data.pipeline_date_min : "",
          template_pipeline: response.data.data.template_pipeline ? response.data.data.template_pipeline : "",
          feature_meeting_mode: response.data.data.feature_meeting_mode ? response.data.data.feature_meeting_mode : "0",
          meeting_auto_cancel: response.data.data.meeting_auto_cancel ? Number(response.data.data.meeting_auto_cancel) : -1,
          feature_reimbursement: response.data.data.feature_reimbursement === "false" ? false : true,
          update_log_hpp_progress: response.data.data.update_log_hpp_progress === "true" ? true : false,
          chat_show_pic_only: response.data.data.chat_show_pic_only === "true" ? true : false,
          chat_superadmin_merchant_only: response.data.data.chat_superadmin_merchant_only === "true" ? true : false,
          radius_visit: response.data.data.radius_visit ? Number(response.data.data.radius_visit) : 1,
          update_meeting: response.data.data.update_meeting === "true" ? true : false,
          unlimited_add_lead_log: response.data.data.unlimited_add_lead_log === "true" ? true : false,
          feature_activities: response.data.data.feature_activities ? response.data.data.feature_activities === 'true' ? true : false : true,
          feature_attendance: response.data.data.feature_attendance ? response.data.data.feature_attendance === 'true' ? true : false : false,
          feature_conference: response.data.data.feature_conference ? response.data.data.feature_conference === 'true' ? true : false : true,
          feature_email: response.data.data.feature_email ? response.data.data.feature_email === 'true' ? true : false : true,
          feature_label: response.data.data.feature_label ? response.data.data.feature_label === 'true' ? true : false : true,
          feature_merchant: response.data.data.feature_merchant ? response.data.data.feature_merchant === 'true' ? true : false : true,
          feature_product: response.data.data.feature_product ? response.data.data.feature_product === 'true' ? true : false : true,
          feature_progress: response.data.data.feature_progress ? response.data.data.feature_progress === 'true' ? true : false : true,
          feature_source: response.data.data.feature_source ? response.data.data.feature_source === 'true' ? true : false : true,
          feature_target: response.data.data.feature_target ? response.data.data.feature_target === 'true' ? true : false : true,
          feature_unit: response.data.data.feature_unit ? response.data.data.feature_unit === 'true' ? true : false : true,
          feature_import_excel_pipeline: response.data.data.feature_import_excel_pipeline ? response.data.data.feature_import_excel_pipeline === 'true' ? true : false : false,
          meeting_visit_disable_capture_camera: response.data.data.meeting_visit_disable_capture_camera ? response.data.data.meeting_visit_disable_capture_camera === 'true' ? true : false : false,
          meeting_done_disable_capture_camera: response.data.data.meeting_done_disable_capture_camera ? response.data.data.meeting_done_disable_capture_camera === 'true' ? true : false : false,
          feature_invoice: response.data.data.feature_invoice ? response.data.data.feature_invoice === 'true' ? true : false : false,
          custom_username_prefix: response.data.data.custom_username_prefix ? response.data.data.custom_username_prefix === 'true' ? true : false : false,
          currency: response.data.data.currency ? response.data.data.currency : '',
          company_vat_percentage: response.data.data.company_vat_percentage ? Number(response.data.data.company_vat_percentage) : 0,
          default_pipeline_view_mode: response.data.data.default_pipeline_view_mode ? response.data.data.default_pipeline_view_mode : "table",
          is_superadmin_allowed_as_pic: response.data.data.is_superadmin_allowed_as_pic ? response.data.data.is_superadmin_allowed_as_pic === 'true' ? true : false : false,
          chat_version: response.data.data.chat_version ? response.data.data.chat_version : "v1",
          sessionsTimeoutInSeconds: response.data.data.sessionsTimeoutInSeconds ? response.data.data.sessionsTimeoutInSeconds : "0",
          allowAgentPreemptiveStartSessions: response.data.data.allowAgentPreemptiveStartSessions ? response.data.data.allowAgentPreemptiveStartSessions === "true" ? true : false : false,
          captionWhenSessionEnded: response.data.data.captionWhenSessionEnded ? response.data.data.captionWhenSessionEnded : "",
          can_init_chat: response.data.data.can_init_chat ? response.data.data.can_init_chat === 'true' ? true : false : false,
          feature_master: response.data.data.feature_master ? response.data.data.feature_master === 'true' ? true : false : true,
          is_pipeline_discount_hidden: response.data.data.is_pipeline_discount_hidden ? response.data.data.is_pipeline_discount_hidden === 'true' ? true : false : false,
          is_pipeline_label_required: response.data.data.is_pipeline_label_required ? response.data.data.is_pipeline_label_required === 'true' ? true : false : false,
          lead_optional_product: response.data.data.lead_optional_product ? response.data.data.lead_optional_product === 'true' ? true : false : false,
          chat_show_lead_pic: response.data.data.chat_show_lead_pic ? response.data.data.chat_show_lead_pic === 'true' ? true : false : false,
          chat_show_merchant_pic: response.data.data.chat_show_merchant_pic ? response.data.data.chat_show_merchant_pic === 'true' ? true : false : false,
        })
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }

  const getCompany = async () => {
    try {
      const response = await getCompanies(token)
      if (response.data.success) {
        setCompanies(response.data.data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }
  const getCompanyCurrency = async () => {
    try {
      const response = await getThisCompanyCurrency(token)
      if (response.data.success) {
        setMultiCurrencies(response.data.data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }

  const getUserSession = async () => {
    try {
      const response = await userSession(token)
      if (response.data.success) {
        setUserSessions(response.data.data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }

  const getUserURL = () => {
    if (user.data.permission_user_target_set === 'ALL') {
      return `${API_URL}users`;
    } else if (user.data.permission_user_target_set === 'TEAM' || user.data.permission_user_target_set === 'TEAM EXCEPT SELF') {
      return `${API_URL}user/one-level-subordinates`;
    } else {
      return `${API_URL}user/subordinates`;
    }
  };

  const logout = () => {
    Swal.fire({
      title: intl.formatMessage({ id: "ALERT.TITLE.LOG_OUT" }),
      text: intl.formatMessage({ id: "ALERT.TEXT.LOG_OUT" }),
      icon: "warning",
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText: intl.formatMessage({ id: "FORM.ACTION.LOG_OUT" }),
      cancelButtonText: intl.formatMessage({ id: "FORM.CONFIRMATION.NO" }),
      showLoaderOnConfirm: true,
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-active-light',
      },
      reverseButtons: true,
      heightAuto: false,
      preConfirm: async () => {
        try {
          const response = await deleteUserSession(token, token);
          if (response?.data?.success) {
            await clearDB();
            localStorage.clear();
            dispatch(auth.actions.logout());
            return true; // sukses, lanjut ke .then
          } else {
            throw new Error("Logout gagal");
          }
        } catch (error: any) {
          Swal.fire({
            icon: 'error',
            title: error?.response?.data?.message || 'Terjadi kesalahan',
            confirmButtonText: 'Ok',
          });
          return false;
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload(); // reload setelah semua proses selesai
      }
    });
  };


  const { data: company = [], isLoading: companyLoading } = useSWR(`${API_URL}company`, fetcher)
  const { data: companyLimitData, isLoading: companyLimitDataLoading } = useSWR(`${API_URL}company/${user.data.company_id}/usage`, fetcher)
  const { data: version = [], error: versionError, isLoading: versionLoading, isValidating: versionValidating } = useSWR(`${API_URL}version`, fetcher)
  const { data: subordinate = [], error: subordinateError, isLoading: subordinateLoading } = useSWR(getUserURL(), fetcher);
  const { data: leadTemplate = [], error: leadTemplateError, isLoading: leadTemplateLoading, isValidating: leadTemplateValidation } = useSWR(`${API_URL}lead-templates`, fetcher);
  // const { data: resultMultiCurrencies = [], error: resultMultiCurrenciesError, isLoading: resultMultiCurrenciesLoading } = useSWR(`${API_URL}currencies`, fetcher)
  const { data: resultMultiMerchant = [], error: resultMultiMerchantError, isLoading: resultMultiMerchantisLoading } = useSWR(`${API_URL}merchant-templates`, fetcher)
  const { data: resultMultiMeeting = [], error: resultMultiMeetingError, isLoading: resultMultiMeetingisLoading } = useSWR(`${API_URL}meeting-templates`, fetcher)
  const { data: resultMultiReimbursement = [], error: resultMultiReimbursementError, isLoading: resultMultiReimbursementisLoading } = useSWR(`${API_URL}reimbursement-templates`, fetcher)
  const { data: templateAnalytic = [], error: templateAnalyticError, isLoading: templateAnalyticIsLoading } = useSWR(`${API_URL}analytics/template`, fetcher)
  const { data: limitReimbursement = [], error: limitReimbursementError, isLoading: limitReimbursementLoading } = useSWR(`${API_URL}user/limit-reimbursment`, fetcher)
  const { data: usersData = [], error: usersError, isLoading: usersLoading } = useSWR(`${API_URL}users`, fetcher)
  const { data: merchantsData = [], error: merchantsError, isLoading: merchantsLoading } = useSWR(`${API_URL}simple-merchants`, fetcher)
  const { data: simpleLeadsData = [], error: simpleLeadsError, isLoading: simpleLeadsLoading } = useSWR(`${API_URL}simple-leads`, fetcher)
  const { data: simpleMeetingsData = [], error: simpleMeetingsError, isLoading: simpleMeetingsLoading } = useSWR(`${API_URL}simple-meetings`, fetcher)
  const { data: simpleProductsData = [], error: simpleProductsError, isLoading: simpleProductsLoading } = useSWR(`${API_URL}simple-products`, fetcher)
  const { data: dataLimitEmail, isLoading: dataLimitEmailLoading } = useSWR<DataLimitEmail>(`${API_URL}email/company-email-limit?companyId=${user.data.company_id}`, fetcher);
  const { data: _limitComponentData = [], error: limitComponentError, isLoading: limitComponentLoading } = useSWR(`${API_URL}menu-analytics/limit`, fetcher)

  // useEffect(() => {
  //   if (!resultMultiCurrenciesLoading && Array.isArray(resultMultiCurrencies) && resultMultiCurrencies.length > 0) {
  //     setMultiCurrencies(resultMultiCurrencies);
  //   }
  // }, [resultMultiCurrencies, resultMultiCurrenciesLoading]);

  useEffect(() => {
    // setIsLoadingSimpleProducts(simpleProductsLoading)
    if (!simpleProductsLoading) {
      setSimpleProducts(simpleProductsData)
    }
  }, [simpleProductsLoading]);

  useEffect(() => {
    // setSimpleMerchantLoading(merchantsLoading)
    // setMerchantLoading(merchantsLoading)
    if (!merchantsLoading) {
      setMerchants(merchantsData)
      setSimpleMerchants(merchantsData)
    }
  }, [merchantsLoading]);

  useEffect(() => {
    // setSimplePipelineLoading(simpleLeadsLoading)
    if (!simpleLeadsLoading) {
      setSimplePipelines(simpleLeadsData)
    }
  }, [simpleLeadsLoading]);

  useEffect(() => {
    // setUserLoading(usersLoading)
    if (!usersLoading) {
      setUsers(usersData)
    }
  }, [usersLoading]);

  useEffect(() => {
    // setSimpleMeetingLoading(simpleMeetingsLoading)
    if (!simpleMeetingsLoading) {
      setSimpleMeetings(simpleMeetingsData)
    }
  }, [simpleMeetingsLoading]);

  useEffect(() => {
    if (!resultMultiMerchantisLoading && Array.isArray(resultMultiMerchant) && resultMultiMerchant.length > 0) {
      setMultiMerchants(resultMultiMerchant);
    }
  }, [resultMultiMerchant, resultMultiMerchantisLoading]);

  useEffect(() => {
    if (!resultMultiReimbursementisLoading && Array.isArray(resultMultiReimbursement) && resultMultiReimbursement.length > 0) {
      setMultiReimbursements(resultMultiReimbursement);
    }
  }, [resultMultiReimbursement, resultMultiReimbursementisLoading]);

  useEffect(() => {
    if (!templateAnalyticIsLoading && Array.isArray(templateAnalytic) && templateAnalytic.length > 0) {
      setTemplatesAnalytic(templateAnalytic);
    }
  }, [templateAnalytic, templateAnalyticIsLoading]);

  useEffect(() => {
    if (!dataLimitEmailLoading && dataLimitEmail !== undefined && dataLimitEmail?.limitEmails > 0) {
      setDataLimitMasterEmail({
        totalEmails: dataLimitEmail.totalEmails,
        limitEmails: dataLimitEmail.limitEmails,
      })
    }
  }, [dataLimitEmail, dataLimitEmailLoading])

  useEffect(() => {
    if (!limitComponentLoading) {
      setLimitComponentData(_limitComponentData)
    }
  }, [_limitComponentData])

  useEffect(() => {
    if (!resultMultiMeetingisLoading && Array.isArray(resultMultiMeeting) && resultMultiMeeting.length > 0) {
      const result = resultMultiMeeting.map((lead: SettingMultiMeetings) => ({
        ...lead,
        label: lead.name,
        value: lead.id,
      }));
      setMultiMeetings([...result]);
    }
  }, [resultMultiMeeting, resultMultiMeetingisLoading]);

  useEffect(() => {
    if (!leadTemplateLoading && leadTemplate.length > 0) {
        const result = leadTemplate.map((lead: SettingMultiPipelines) => ({
          ...lead,
          label: lead.name,
          value: lead.id,
        }));

        setMultiPipelines(result);
    }
  }, [leadTemplateLoading]);

  useEffect(() => {
    if (!leadTemplateLoading && leadTemplate)
      if (leadTemplate && leadTemplate.length > 0 && templatePipelineId) {
        const result = leadTemplate.map((lead: SettingMultiPipelines) => ({
          ...lead,
          label: lead.name,
          value: lead.id,
        }));

        if (result) {
          setSelectMultiPipeline(result.find((pipeline: SettingMultiPipelines) => pipeline.id === templatePipelineId))
        }
      }
  }, [leadTemplate, leadTemplateLoading, templatePipelineId])

  useEffect(() => {
    if (!companyLoading) {
      setCompanies(company)
    }
  }, [company])

  useEffect(() => {
    if (!companyLimitDataLoading) {
      setCompanyLimit(companyLimitData)
    }
  }, [companyLimitData])

  useEffect(() => {
    if (!limitReimbursementLoading) {
      setRemainingLimitMonth({ idr: limitReimbursement.remainingLimitMonth.IDR, usd: limitReimbursement.remainingLimitMonth.USD })
      setRemainingLimitYear({ idr: limitReimbursement.remainingLimitYear.IDR, usd: limitReimbursement.remainingLimitYear.USD })
    }
  }, [limitReimbursement])

  useEffect(() => {
    if (user) {
      let dateNow = moment().format('YYYY-MM-DD')
      let dateExp = moment(user.data.company_date_expired).format('YYYY-MM-DD')
      let expired = moment(dateExp).isBefore(dateNow)
      setIsShowModalSuspend(user.data.companyIsSuspended)
      
      if (expired) {
        setIsShowModalExpired(true)
      }
    }
  }, [user])

  useEffect(() => {
    if (!versionLoading) {
      const checkVersion = async () => {
        const storedVersion = localStorage.getItem("version-crm");

        if (!storedVersion) {
          localStorage.setItem("version-crm", version);
        } else if (version !== storedVersion) {
          localStorage.setItem("version-crm", version);
          await clearDB(); // pastikan DB dibersihkan dulu
          window.location.reload(); // baru reload
        }
      };

      checkVersion();
    }
  }, [version]);

  useEffect(() => {
    if (!subordinateLoading) {
      const data = subordinate.map((subordinate: Subordinate) => ({
        value: subordinate.id,
        label: subordinate.name,
      }));

      if (
        user.data.permission_user_target_set === 'WHOLE TEAM' ||
        user.data.permission_user_target_set === 'TEAM'
      ) {
        data.unshift({ value: user.data.id, label: user.data.name });
      }
      setSubordinates(data);
    }
  }, [subordinate]);

  useEffect(() => {
    getSetting()
    getCompanyCurrency()
  }, [])

  useEffect(() => {
    setFetchCounter(0)
  }, [pathname])

  useModalEffect({
    showModal: isShowModalExpired,
    setShowModal: setIsShowModalExpired,
    modalId: `expired-modal`
  })

  useModalEffect({
    showModal: isShowModalSuspend,
    setShowModal: setIsShowModalSuspend,
    modalId: `suspend-modal`
  })

  return (
    <>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <div className='menu-content d-flex align-items-center px-3'>
            <div className='d-flex flex-column'>
              <div className='d-flex justify-content-start align-items-center position-relative'>
                <button
                  type="button"
                  className="btn btn-icon btn-circle btn-active-color-primary bg-body shadow position-absolute"
                  style={{
                    bottom: '-7px',
                    left: '-2px',
                    zIndex: '99',
                    width: '24px',
                    height: '24px'
                  }}
                  onClick={() => {
                    setShowUpdateProfilePicture(true)
                  }}
                >
                  <i className="fas fa-pen fs-6"></i>
                </button>
                {
                  userProfile ? (
                    <div className='symbol symbol-circle symbol-50px'>
                      <img src={userProfile} className="profile-picture" alt="user"></img>
                    </div>
                  ) : (
                    <span className="ms-5">
                      <i className="fas fa-user" style={{ fontSize: '2.5rem' }}></i>
                    </span>
                  )
                }
                <div className='d-flex flex-column ms-3'>
                  <div className='fw-bolder d-flex align-items-center fs-5'>{user.data.name}</div>
                  <div className='fw-bold text-muted fs-7'>
                    Exp. {moment(companies.date_expired).format('DD MMMM YYYY')}
                  </div>
                </div>
              </div>
              <div className='d-flex align-items-center text-gray-400 mt-3'>
                <span className='svg-icon svg-icon-4 me-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      opacity='0.3'
                      d='M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 7C10.3 7 9 8.3 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 8.3 13.7 7 12 7Z'
                      fill='black'
                    ></path>
                    <path
                      d='M12 22C14.6 22 17 21 18.7 19.4C17.9 16.9 15.2 15 12 15C8.8 15 6.09999 16.9 5.29999 19.4C6.99999 21 9.4 22 12 22Z'
                      fill='black'
                    ></path>
                  </svg>
                </span>
                {customNumberFormat(companies.usersCount ?? 0)} /{' '}
                {customNumberFormat(companies.limit_user ?? 0)}
              </div>
              {
                user.data.isWaSessionActive === undefined ?
                  <span className="badge badge-light-danger fw-bolder mt-2" style={{ width: 'fit-content' }}>
                    <i className="fas fa-link me-2 fs-8"></i> ?
                  </span >
                  :
                  user.data.isWaSessionActive ?
                    <span className="badge badge-light-success fw-bolder mt-2" style={{ width: 'fit-content' }}>
                      <i className="fas fa-link me-2 fs-8"></i> {intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CONNECT_CHAT' })}
                    </span >
                    :
                    <span className="badge badge-light-danger fw-bolder mt-2" style={{ width: 'fit-content' }}>
                      <i className="fas fa-unlink me-2 fs-8"></i> {intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DISCONNECT_CHAT' })}
                    </span>
              }
            </div>
          </div>
        </div >

        {
          !user.data.is_superadmin && (
            <div className='menu-item px-5'>
              <div className="rounded min-w-125px py-3 px-4 my-1" style={{ border: "1px dashed rgb(0 0 0 / 20%)" }}>
                <div className="d-flex align-items-center d-flex gap-2">
                  <div className="fs-6 fw-bolder counted">Rp {remainingLimitMonth.idr !== null ? currencyFormatter(remainingLimitMonth.idr) : "-"}</div>
                  <div className="fs-6 counted">|</div>
                  <div className="fs-6 fw-bolder counted">$ {remainingLimitMonth.usd !== null ? currencyFormatter(remainingLimitMonth.usd) : "-"}</div>
                </div>
                <div className="fw-bold fs-7 text-muted">{intl.formatMessage({ id: "FORM.LABEL.REMAINING_REIMBURSEMENT_MONTH" })}</div>
              </div>
              <div className="rounded min-w-125px py-3 px-4 my-1" style={{ border: "1px dashed rgb(0 0 0 / 20%)" }}>
                <div className="d-flex align-items-center d-flex gap-2">
                  <div className="fs-6 fw-bolder counted">Rp {remainingLimitYear.idr !== null ? currencyFormatter(remainingLimitYear.idr) : "-"}</div>
                  <div className="fs-6 counted">|</div>
                  <div className="fs-6 fw-bolder counted">$ {remainingLimitYear.usd !== null ? currencyFormatter(remainingLimitYear.usd) : "-"}</div>
                </div>
                <div className="fw-bold fs-7 text-muted">{intl.formatMessage({ id: "FORM.LABEL.REMAINING_REIMBURSEMENT_YEAR" })}</div>
              </div>
            </div>
          )
        }

        <div className='separator my-2'></div>

        <div className='menu-item px-5'>
          {
            user.data.is_superadmin && (
              <a className="menu-link px-5" href='/manage-account' target='_blank'>
                <span className="fas fa-user-cog fs-4 menu-icon"></span>
                <span className="menu-title">{intl.formatMessage({ id: "FORM.LABEL.MANAGE_ACCOUNT" })}</span>
              </a>
            )
          }
          <a data-bs-toggle="modal" data-bs-target="#modal-change-password" className="menu-link px-5">
            <span className="fas fa-key fs-4 menu-icon"></span>
            <span className="menu-title">{intl.formatMessage({ id: "FORM.ACTION.CHANGE_PASSWORD" })}</span>
          </a>
          <a data-bs-toggle="modal" data-bs-target="#manage-user-phone-modal" className="menu-link px-5">
            <span className="fas fa-phone fs-4 menu-icon"></span>
            <span className="menu-title">{intl.formatMessage({ id: "MENU.MANAGE_PHONES" })}</span>
          </a>
          <a onClick={() => { setOpenDrawer(true); getUserSession() }} className="menu-link px-5">
            <span className="fas fa-link fs-4 menu-icon"></span>
            <span className="menu-title">{intl.formatMessage({ id: "FORM.ACTION.LINKED_DEVICES" })}</span>
          </a>
          <a href="/open-api" target='_blank' className="menu-link px-5">
            <span className="fas fa-code fs-4 menu-icon"></span>
            <span className="menu-title">{intl.formatMessage({ id: "MENU.API_DOCUMENTATION" })}</span>
          </a>
          <a onClick={logout} className="menu-link px-5" id="btnLogout">
            <span className="fas fa-sign-out-alt fs-4 menu-icon"></span>
            <span className="menu-title">{intl.formatMessage({ id: "FORM.ACTION.LOG_OUT" })}</span>
          </a>
        </div>
      </div >

      <Drawer size='xs' open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <Drawer.Header>
          <Drawer.Title style={{ fontWeight: "500" }}>{intl.formatMessage({ id: "FORM.ACTION.LINKED_DEVICES" })}</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body style={{ padding: '30px 30px' }}>
          {userSessions.map((data, index) => {
            return <ListLinkDevice data={data} />
          })}
        </Drawer.Body>
      </Drawer>
    </>
  )
}

export { HeaderUserMenu }
